export const takenTestQuestionSingleResourceType = "taken_test_question_single" as const;
